<template>
  <div
    v-if="isShowFooter"
    class="bg-white sticky bottom-0"
    style="box-shadow: 0 0 8px rgba(152, 163, 190, 0.3)"
  >
    <div class="border-t border-gray-12">
      <div class="xl:container mx-auto relative">
        <div
          class="flex items-center justify-end px-8 relative sp-justify-around"
          style="height: 64px"
        >
          <div
            v-if="
              transactionStatusPram.selectStatus ===
              FILTER_NOT_SELLER_RESPONDED_YET
            "
            class="flex justify-end relative"
          >
            <button
              class="flex px-14 justify-center items-center h-12 rounded-lg border border-gray-38 hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10 focus:outline-none sp-display-none"
              @click="$emit('clickDecline')"
            >
              <span class="text-gray-92 text-base font-bold">辞退する</span>
            </button>
            <a
              :href="
                newNextDomain +
                '/tx-select/' +
                transaction.transaction_id +
                '/apply'
              "
              target="_blank"
            >
              <button
                class="flex justify-center items-center ml-2 h-12 rounded-lg bg-coral-main hover:button focus:outline-none"
                style="width: 242px"
              >
                <div class="mr-1">
                  <img src="@/assets/icons/EditWhite.svg" />
                </div>
                <span class="text-white text-base font-bold">応募へ進む</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FILTER_NOT_SELLER_RESPONDED_YET,
  FILTER_SELLER_RESPONDED_OK,
} from '@/utils/transctionSelectionStatus';
import { computed, reactive, toRefs } from 'vue';

export default {
  props: {
    transaction: {
      required: true,
    },
    transactionStatusPram: {
      required: true,
    },
  },
  emits: ['close'],
  setup(props) {
    const state = reactive({
      isShowFooter: computed(() => {
        if (props.transaction.transaction_type === 'normal') {
          return false;
        }
        if (props.transaction.is_expired) {
          return false;
        }
        if (props.transaction.is_communication_started) {
          return false;
        }
        if (
          props.transactionStatusPram.selectStatus !==
          FILTER_NOT_SELLER_RESPONDED_YET
        ) {
          return false;
        }

        return true;
      }),
    });

    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    return {
      ...toRefs(state),
      newNextDomain,
      FILTER_NOT_SELLER_RESPONDED_YET,
      FILTER_SELLER_RESPONDED_OK,
    };
  },
};
</script>

<style lang="scss" scoped>
.right-enter-from,
.right-leave-to {
  transform: translateX(100vw);
}
.right-enter-active,
.right-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}

@media (max-width: 640px) {
  .sp-display-none {
    display: none;
  }

  .sp-justify-around {
    justify-content: space-around;
  }
}
</style>
